import React, { useState } from 'react';
import { useFirebase } from '../contexts/FirebaseContext';
import { useUser } from '../contexts/UserContext';

export const AuthLoading = () => (
  <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-blue-900 to-blue-700">
    <div className="text-white text-xl" role="status">Loading...</div>
  </div>
);

export default function AccountRecovery() {
  const { user, error, logout } = useFirebase();
  const { refreshUserData } = useUser();
  const [signOutError, setSignOutError] = useState('');
  const [busy, setBusy] = useState(false);
  const handleSignOut = async () => {
    setBusy(true);
    try { await logout(); }
    catch { setSignOutError('Sign out failed. Please try again.'); }
    finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-gradient-to-br from-blue-900 to-blue-700">
      <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">{error ? 'Sign-in is unavailable' : 'Unable to load your profile'}</h2>
        <p className="text-gray-700 mb-6" role="alert">{error
          ? 'We could not connect to authentication. Please reload and try again.'
          : 'You are still signed in. Check your connection and retry. Your account has not been deleted.'}</p>
        <button className="w-full py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg"
          onClick={() => error ? window.location.reload() : refreshUserData()}>
          {error ? 'Reload' : 'Retry loading profile'}
        </button>
        {user && <button disabled={busy} className="w-full mt-4 text-blue-600" onClick={handleSignOut}>Sign out</button>}
        {signOutError && <p className="text-red-600 mt-4" role="alert">{signOutError}</p>}
      </div>
    </div>
  );
}
